<div class="w-full h-full bg-[#1a1a1a] text-white overflow-hidden flex flex-col">
    <!-- Header com botão fechar -->
    <div class="sticky top-0 z-10 bg-[#1a1a1a]/95 backdrop-blur-sm border-b border-zinc-800">
        <div class="flex items-center justify-between px-6 py-4">
            <div class="flex items-center gap-3">
                <div class="w-10 h-10 rounded-full bg-[#E4811E]/20 flex items-center justify-center">
                    <mat-icon svgIcon="heroicons_outline:newspaper" class="text-[#E4811E] icon-size-5"></mat-icon>
                </div>
                <div>
                    <span class="text-white/50 text-xs uppercase tracking-wider">Newsletter</span>
                    @if (newsletter?.topicoNome) {
                        <p class="text-[#E4811E] text-sm font-medium">{{ newsletter.topicoNome }}</p>
                    }
                </div>
            </div>
            <button 
                mat-icon-button 
                class="text-white/60 hover:text-white hover:bg-zinc-800 transition-colors"
                (click)="fechar()">
                <mat-icon svgIcon="heroicons_outline:x-mark"></mat-icon>
            </button>
        </div>
    </div>

    <!-- Conteúdo Principal com Scroll -->
    <div class="flex-1 overflow-y-auto">
        @if (newsletter) {
            <!-- Imagem de Destaque -->
            @if (newsletter.arquivoBase64) {
                <div class="relative w-full bg-zinc-900">
                    <div class="max-w-4xl mx-auto">
                        <img
                            [src]="newsletter.arquivoBase64"
                            [alt]="newsletter.titulo"
                            class="w-full h-auto max-h-[50vh] object-contain"
                            loading="eager"
                        />
                    </div>
                </div>
            }

            <!-- Conteúdo do Artigo -->
            <div class="max-w-4xl mx-auto px-6 md:px-12 py-8">
                <!-- Meta informações -->
                <div class="flex flex-wrap items-center gap-4 mb-6 text-white/50 text-sm">
                    @if (newsletter.dataCriacao) {
                        <div class="flex items-center gap-2">
                            <mat-icon svgIcon="heroicons_outline:calendar" class="icon-size-4"></mat-icon>
                            <span>{{ newsletter.dataCriacao | date:'dd \'de\' MMMM \'de\' yyyy' }}</span>
                        </div>
                    }
                    @if (newsletter.autor) {
                        <div class="flex items-center gap-2">
                            <mat-icon svgIcon="heroicons_outline:user" class="icon-size-4"></mat-icon>
                            <span>{{ newsletter.autor }}</span>
                        </div>
                    }
                    @if (newsletter.topicoNome) {
                        <span class="px-3 py-1 bg-[#E4811E]/20 text-[#E4811E] text-xs font-medium rounded-full">
                            {{ newsletter.topicoNome }}
                        </span>
                    }
                </div>

                <!-- Título -->
                <h1 class="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-8 text-white">
                    {{ newsletter.titulo }}
                </h1>

                <!-- Divisor decorativo -->
                <div class="flex items-center gap-4 mb-8">
                    <div class="h-1 w-16 bg-[#E4811E] rounded-full"></div>
                    <div class="h-1 w-8 bg-[#E4811E]/50 rounded-full"></div>
                    <div class="h-1 w-4 bg-[#E4811E]/25 rounded-full"></div>
                </div>

                <!-- Texto do Artigo -->
                <article class="prose prose-invert prose-lg max-w-none">
                    <div class="text-white/80 text-base md:text-lg leading-relaxed whitespace-pre-line break-words newsletter-content">
                        {{ newsletter.texto }}
                    </div>
                </article>

                <!-- Fonte da Imagem -->
                @if (newsletter.fonteImagem) {
                    <div class="mt-8 pt-6 border-t border-zinc-800">
                        <p class="text-white/40 text-sm">
                            <span class="font-medium">Fonte da imagem:</span> {{ newsletter.fonteImagem }}
                        </p>
                    </div>
                }
            </div>
        } @else {
            <!-- Loading State -->
            <div class="flex items-center justify-center h-64">
                <div class="flex flex-col items-center gap-4">
                    <div class="w-12 h-12 border-4 border-[#E4811E]/30 border-t-[#E4811E] rounded-full animate-spin"></div>
                    <p class="text-white/50">Carregando newsletter...</p>
                </div>
            </div>
        }
    </div>

    <!-- Footer com Ações -->
    @if (newsletter) {
        <div class="sticky bottom-0 bg-[#1a1a1a]/95 backdrop-blur-sm border-t border-zinc-800">
            <div class="max-w-4xl mx-auto px-6 py-4">
                <div class="flex flex-wrap items-center justify-between gap-4">
                    <!-- Info do Autor -->
                    <div class="flex items-center gap-3">
                        <div class="w-10 h-10 rounded-full bg-zinc-800 flex items-center justify-center">
                            <mat-icon svgIcon="heroicons_outline:user" class="text-white/60 icon-size-5"></mat-icon>
                        </div>
                        <div>
                            <p class="text-white text-sm font-medium">{{ newsletter.autor || 'Equipe Edduca' }}</p>
                            <p class="text-white/50 text-xs">{{ newsletter.dataCriacao | date:'dd/MM/yyyy \'às\' HH:mm' }}</p>
                        </div>
                    </div>

                    <!-- Botões de Ação -->
                    <div class="flex items-center gap-3">
                        @if (newsletter.arquivoBase64) {
                            <a 
                                mat-stroked-button
                                class="!border-zinc-700 !text-white hover:!bg-zinc-800"
                                [href]="newsletter.arquivoBase64"
                                download="newsletter-imagem"
                                rel="noopener">
                                <mat-icon svgIcon="heroicons_outline:arrow-down-tray" class="icon-size-5 mr-2"></mat-icon>
                                Baixar Imagem
                            </a>
                        }
                        <button 
                            mat-flat-button 
                            class="!bg-[#E4811E] hover:!bg-[#d4751a] !text-white"
                            (click)="fechar()">
                            <mat-icon svgIcon="heroicons_outline:x-mark" class="icon-size-5 mr-2"></mat-icon>
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    }
</div>
